import React, { useState, useEffect } from "react";
import api from "../../services/api";

// Miniatura de mídia citada (reply/quote). /public exige token JWT, então
// buscamos via `api` (Authorization header) e mostramos um blob — um
// <img src> cru daria 401 (mesmo motivo do ModalImageCors do chat).
const QuotedMediaThumb = ({ mediaUrl, size = 44, marginLeft = 8 }) => {
  const [blobUrl, setBlobUrl] = useState("");

  useEffect(() => {
    if (!mediaUrl) return undefined;
    let alive = true;
    let objUrl = "";
    const src = /^(https?:|blob:|data:)/.test(mediaUrl)
      ? mediaUrl
      : `/public/${encodeURIComponent(mediaUrl)}`;
    (async () => {
      try {
        const { data, headers } = await api.get(src, { responseType: "blob" });
        objUrl = window.URL.createObjectURL(
          new Blob([data], { type: headers["content-type"] })
        );
        if (alive) setBlobUrl(objUrl);
      } catch {
        /* mídia indisponível — não mostra a miniatura */
      }
    })();
    return () => {
      alive = false;
      if (objUrl) window.URL.revokeObjectURL(objUrl);
    };
  }, [mediaUrl]);

  if (!blobUrl) return null;
  return (
    <img
      src={blobUrl}
      alt=""
      style={{
        width: size,
        height: size,
        objectFit: "cover",
        borderRadius: 6,
        flex: "none",
        marginLeft,
      }}
    />
  );
};

export default QuotedMediaThumb;
